import { Component, inject, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RaButtonComponent, RaInputComponent, RaToastService } from '@shared/components';
import { OrderCreateService } from '../../services/order-create.service';

@Component({
    selector: 'order-description',
    templateUrl: 'order-description.component.html',
    styleUrl: 'order-description.component.scss',
    imports: [RaInputComponent, ReactiveFormsModule, RaButtonComponent, TranslatePipe],
})
export class OrderDescriptionComponent {
    public close = output<void>();

    // * [Injects]
    private _raToastService = inject(RaToastService);
    private _translate = inject(TranslateService);
    public orderCreateService = inject(OrderCreateService);

    // * [Form Controls]
    public formControl = new FormControl<string>(this.orderCreateService.description(), [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
    ]);

    /**
     * Avança para o próximo passo
     */
    public nextStep(): void {
        if (this.formControl.invalid) {
            this.formControl.markAsTouched();
            this._raToastService.warning({
                message: this._translate.instant('order.description.formInvalid'),
            });
            return;
        }

        this.orderCreateService.description.set(this.formControl.value);
        this.orderCreateService.nextStep();
    }
}
